  // src/pages/admin/AdminTasks.jsx
  import React, { useState } from "react";
  import { useAuth } from "../../context/AuthContext";
  import {
    useAllTasks,
    useAllUsers,
    createTask,
    updateTaskStatus,
    updateTask,
    deleteTask,
  } from "../../hooks/useFirestore";
  import { ADMIN_NAV } from "../../utils/navigation";
  import Layout from "../../components/common/Layout";
function getTodayStr() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
}
  export default function AdminTasks() {
    const { userProfile } = useAuth();
    const { data: tasks, loading: tLoad } = useAllTasks();
    const { data: users } = useAllUsers();
    const employees = users.filter((u) => u.role !== "admin" && u.isActive);

    const [form, setForm] = useState({
      title: "",
      description: "",
      assignedTo: "",
      priority: "medium",
      deadline: "",
    });
    const [editingTask, setEditingTask] = useState(null);
    const [saving, setSaving] = useState(false);
    const [msg, setMsg] = useState("");
    const [filterStatus, setFilterStatus] = useState("all");

    function handleChange(e) {
      setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
    }

    function handleEditClick(t) {
      setEditingTask(t);
      setMsg("");
      let formattedDeadline = "";
      if (t.deadline) {
        if (t.deadline.toDate) {
          formattedDeadline = t.deadline.toDate().toISOString().split("T")[0];
        } else {
          formattedDeadline = t.deadline;
        }
      }
      setForm({
        title: t.title || "",
        description: t.description || "",
        assignedTo: t.assignedTo || "",
        priority: t.priority || "medium",
        deadline: formattedDeadline,
      });
    }

    function handleCancelEdit() {
      setEditingTask(null);
      setMsg("");
      setForm({
        title: "",
        description: "",
        assignedTo: "",
        priority: "medium",
        deadline: "",
      });
    }

    async function handleDeleteClick(taskId) {
      if (!window.confirm("Are you sure you want to delete this task?")) {
        return;
      }
      try {
        await deleteTask(taskId, userProfile);
        setMsg("✅ Task Deleted Successfully");
        if (editingTask && editingTask.id === taskId) {
          setEditingTask(null);
          setForm({
            title: "",
            description: "",
            assignedTo: "",
            priority: "medium",
            deadline: "",
          });
        }
      } catch (err) {
        setMsg("❌ " + err.message);
      }
    }

    async function handleAssign(e) {
      e.preventDefault();
      setSaving(true);
      setMsg("");

      const deadlineDate = new Date(form.deadline);
      if (deadlineDate.getDay() === 0) {
        setMsg("❌ Sundays cannot be selected as a deadline.");
        setSaving(false);
        return;
      }

      const assignee = users.find((u) => u.uid === form.assignedTo);
      if (!assignee) {
        setMsg("❌ Select an assignee.");
        setSaving(false);
        return;
      }
      if (form.title.trim().length > 100) {
        setMsg("❌ Task title cannot exceed 100 characters");
        setSaving(false);
        return;
      }
      try {
        if (editingTask) {
          await updateTask(editingTask.id, {
            title: form.title,
            description: form.description,
            assignedTo: assignee.uid,
            assignedToName: assignee.displayName,
            priority: form.priority,
            deadline: form.deadline,
          }, userProfile);
          setMsg("✅ Task Updated Successfully");
          setEditingTask(null);
        } else {
          await createTask({
            title: form.title,
            description: form.description,
            assignedTo: assignee.uid,
            assignedToName: assignee.displayName,
            assignedBy: userProfile.uid,
            assignedByName: userProfile.displayName,
            teamId: assignee.teamId || assignee.uid,
            department: assignee.department,
            priority: form.priority,
            deadline: form.deadline,
          });
          setMsg("✅ Task Created Successfully");
        }
        setForm({
          title: "",
          description: "",
          assignedTo: "",
          priority: "medium",
          deadline: "",
        });
      } catch (err) {
        setMsg("❌ " + err.message);
      }
      setSaving(false);
    }

    const filtered = tasks.filter(
      (t) => filterStatus === "all" || t.status === filterStatus,
    );

    return (
      <Layout navItems={ADMIN_NAV} panelLabel="Admin Panel">
        <div className="page-header">
          <h1 className="page-title">Tasks</h1>
        </div>

        <div
  className="two-col-layout"
  style={{
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "1.5rem",
    alignItems: "start",
  }}
>
          <div
  className="form-card"
  style={{
    position: "sticky",
    top: "1.5rem",
    alignSelf: "start",
    height: "fit-content",
  }}
>
            <h3 className="form-card-title">{editingTask ? "Edit Task" : "Assign Task"}</h3>
            {msg && (
              <div
                className={msg.startsWith("✅") ? "form-success" : "form-error"}
              >
                {msg}
              </div>
            )}
            <form onSubmit={handleAssign}>
              <div className="form-group">
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <label>Title *</label>
                  <span style={{ fontSize: "0.72rem", color: form.title.length > 100 ? "var(--red)" : "var(--text-muted)" }}>
                    {100 - form.title.length} characters remaining
                  </span>
                </div>
                <input
                  name="title"
                  value={form.title}
                  onChange={handleChange}
                  required
                  maxLength={120}
                  placeholder="Task title"
                />
              </div>
              <div className="form-group">
                <label>Assign To *</label>
                <select
                  name="assignedTo"
                  value={form.assignedTo}
                  onChange={handleChange}
                  required
                >
                  <option value="">— Select employee —</option>
                  {employees.map((u) => (
                    <option key={u.uid} value={u.uid}>
                      {u.displayName} ({u.department})
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Priority</label>
                  <select
                    name="priority"
                    value={form.priority}
                    onChange={handleChange}
                  >
                    <option value="high">🔴 High</option>
                    <option value="medium">🟡 Medium</option>
                    <option value="low">🟢 Low</option>
                  </select>
                </div>
                <div className="form-group">
  <label>Deadline *</label>
  <input
    name="deadline"
    type="date"
    value={form.deadline}
    onChange={handleChange}
    required
    min={getTodayStr()}
  />
</div>
              </div>
              <div className="form-group">
                <label>Description *</label>
                <textarea
                  name="description"
                  value={form.description}
                  onChange={handleChange}
                  rows={3}
                  placeholder="Task details…"
                  required
                />
              </div>
              <div style={{ display: "flex", gap: "0.5rem" }}>
                <button type="submit" className="btn-primary" disabled={saving} style={{ flex: 1 }}>
                  {saving ? (editingTask ? "Updating…" : "Assigning…") : (editingTask ? "Update Task" : "Assign Task")}
                </button>
                {editingTask && (
                  <button type="button" className="btn-secondary" onClick={handleCancelEdit} disabled={saving}>
                    Cancel
                  </button>
                )}
              </div>
            </form>
          </div>

          <div className="dashboard-card">
            <div className="card-header">
              <h3 className="card-title">All Tasks</h3>
              <select
                className="filter-select-sm"
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
              >
                <option value="all">All</option>
                <option value="PENDING">Todo</option>
                <option value="IN_PROGRESS">In Progress</option>
                <option value="COMPLETED">Completed</option>
                <option value="BLOCKED">Blocked</option>
              </select>
            </div>
            {tLoad ? (
              <div className="card-loading">Loading…</div>
            ) : filtered.length === 0 ? (
              <div className="card-empty">No tasks.</div>
            ) : (
              <div className="task-list">
                {filtered.map((t) => (
                  <div key={t.id} className="task-card">
                    <div className="task-card-header">
                      <span className="task-title">{t.title}</span>
                      <PriorityPill priority={t.priority} />
                    </div>
                   <div className="task-card-meta">
  <span
    style={{
      display: "flex",
      alignItems: "center",
      gap: "4px",
    }}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      width="16"
      height="16"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
      />
    </svg>

    {t.assignedToName}
  </span>

  <span
    style={{
      display: "flex",
      alignItems: "center",
      gap: "4px",
    }}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      width="16"
      height="16"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
      />
    </svg>

    {t.deadline?.toDate?.()?.toLocaleDateString?.("en-IN") ||
      t.deadline}
  </span>
</div>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "0.75rem" }}>
                      <StatusBar status={t.status} taskId={t.id} canEdit={true} />
                      <div style={{ display: "flex", gap: "0.375rem" }}>
                        <button
                          type="button"
                          className="btn-secondary-sm"
                          onClick={() => handleEditClick(t)}
                          style={{ padding: "0.25rem 0.5rem", fontSize: "0.75rem", display: "flex", alignItems: "center", gap: "4px" }}
                        >
                          ✏️ Edit
                        </button>
                        <button
                          type="button"
                          className="btn-danger-sm"
                          onClick={() => handleDeleteClick(t.id)}
                          style={{ padding: "0.25rem 0.5rem", fontSize: "0.75rem", display: "flex", alignItems: "center", gap: "4px" }}
                        >
                          🗑️ Delete
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </Layout>
    );
  }

  export function PriorityPill({ priority }) {
    const map = { high: "red", medium: "amber", low: "green" };
    return (
      <span className={`status-pill status-pill--${map[priority] || "gray"}`}>
        {priority}
      </span>
    );
  }

  export function StatusBar({ status, taskId, canEdit }) {
    const [updating, setUpdating] = useState(false);
    const statuses = ["PENDING", "IN_PROGRESS", "COMPLETED", "BLOCKED"];
    const labels = {
      PENDING: "Todo",
      IN_PROGRESS: "In Progress",
      COMPLETED: "Completed",
      BLOCKED: "Blocked",
    };
    const colors = { PENDING: "gray", IN_PROGRESS: "blue", COMPLETED: "green", BLOCKED: "red" };

    async function handleChange(e) {
      if (!canEdit) return;
      setUpdating(true);
      await updateTaskStatus(taskId, e.target.value);
      setUpdating(false);
    }

    if (!canEdit) {
      return (
        <span className={`status-pill status-pill--${colors[status] || "gray"}`}>
          {labels[status] || status}
        </span>
      );
    }

    return (
      <select
        className={`status-select status-select--${colors[status] || "gray"}`}
        value={status}
        onChange={handleChange}
        disabled={updating}
      >
        {statuses.map((s) => (
          <option key={s} value={s}>
            {labels[s]}
          </option>
        ))}
      </select>
    );
  }
